// https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Math/round
// 上記より引用

/**
 * 四捨五入します
 * @param number 数値
 * @param precision 少数第何位まで有効にするか。 少数第 precision+1 位で四捨五入する。
 */
export default function round(number: number, precision: number) {
    var shift = function(number: number, precision: number, reverseShift: boolean) {
        if (reverseShift) {
            precision = -precision;
        }
        var numArray = ('' + number).split('e');
        return +(numArray[0] + 'e' + (numArray[1] ? +numArray[1] + precision : precision));
    };
    return shift(Math.round(shift(number, precision, false)), precision, true);
}
